import { Fragment, useState, useRef, useEffect } from 'react';
import { isStarted } from 'conversations-async-data/async-data/operators/statusComparators';
import { useThreadDetails } from '../thread-details-feature/public/hooks/useThreadDetails';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { EllipsesIcon } from 'foundations-assets';
// @ts-expect-error type not available yet
import { getEmail } from 'conversations-internal-schema/visitor/operators/visitorGetters';
import { getIsBlocked, getIsFiltered, getOriginalGenericChannelId, getVisitor } from 'conversations-thread-data/thread-details/public/operators';
import { SEND_TRANSCRIPT_PROMPT, BLOCK_THREAD, MOVE_TO_INBOX_PROMPT } from './promptNames';
import MoreActionsPrompts from './MoreActionsPrompts';
import AsyncMoreActionsDropdownOptions from './async/AsyncMoreActionsDropdownOptions';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DropdownIconButton = buttonProps => {
  return /*#__PURE__*/_jsx(IconButton, Object.assign({
    paddingInline: "100"
  }, buttonProps, {
    // The parent specifies buttonSize="small", but we have to specify "medium" here, otherwise the Ellipsis icon does not appear at all
    size: "medium",
    children: /*#__PURE__*/_jsx(EllipsesIcon, {})
  }));
};
DropdownIconButton.displayName = 'DropdownIconButton';
const MoreActionsDropdown = ({
  disabled,
  inboxId,
  isClosingCurrentConversation,
  isKnownVisitor,
  closeThread,
  restoreThread,
  threadId,
  threadDetails,
  properties
}) => {
  const {
    asyncFilterChangeRequest
  } = useThreadDetails({
    threadId
  });
  const [showSendTranscriptPrompt, setSendTranscriptPrompt] = useState(false);
  const [showBlockThreadPrompt, setBlockThreadPrompt] = useState(false);
  const [showMoveToInboxPrompt, setMoveToInboxPrompt] = useState(false);
  const [showMarkAsSpamPrompt, setMarkAsSpamPrompt] = useState(false);
  const [hasBlockBeenClicked, setHasBlockBeenClicked] = useState(false);
  const isVisitorBlocked = getIsBlocked(threadDetails);
  const isThreadFiltered = getIsFiltered(threadDetails);
  const genericChannelId = getOriginalGenericChannelId(threadDetails);
  const visitor = getVisitor(threadDetails);
  const visitorEmailAddress = getEmail(visitor);
  const isLoading = isStarted(asyncFilterChangeRequest);
  const prevIsLoading = useRef(isLoading);
  useEffect(() => {
    if (prevIsLoading.current && !isLoading) {
      setHasBlockBeenClicked(false);
    }
  }, [isLoading]);
  useEffect(() => {
    prevIsLoading.current = isLoading;
  }, [isLoading]);
  const openPrompt = prompt => {
    switch (prompt) {
      case SEND_TRANSCRIPT_PROMPT:
        setSendTranscriptPrompt(true);
        break;
      case BLOCK_THREAD:
        setBlockThreadPrompt(true);
        break;
      case MOVE_TO_INBOX_PROMPT:
        setMoveToInboxPrompt(true);
        break;
      default:
        break;
    }
  };
  const renderContent = () => {
    return /*#__PURE__*/_jsx(AsyncMoreActionsDropdownOptions, {
      isVisitorBlocked: isVisitorBlocked,
      isThreadFiltered: isThreadFiltered,
      isClosingCurrentConversation: isClosingCurrentConversation,
      isCloseConversationDisabled: false,
      openMarkAsSpamPrompt: () => setMarkAsSpamPrompt(true),
      openPrompt: openPrompt,
      closeThread: closeThread,
      restoreThread: restoreThread,
      disabled: disabled,
      threadId: threadId,
      genericChannelId: genericChannelId,
      setBlockClicked: () => setHasBlockBeenClicked(true)
    });
  };
  if (isLoading && hasBlockBeenClicked) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      size: "extra-small"
    });
  }
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(Dropdown, {
      animateOnToggle: true,
      buttonUse: 'tertiary-light',
      buttonSize: "small",
      Button: DropdownIconButton,
      Content: renderContent,
      disabled: disabled,
      "data-test-id": "more-actions-dropdown"
      // Do not show the caret since the icon is already an ellipsis
      ,
      caretRenderer: null
    }), /*#__PURE__*/_jsx(MoreActionsPrompts, {
      isKnownVisitor: isKnownVisitor,
      isThreadFiltered: !!isThreadFiltered,
      threadId: threadId,
      inboxId: inboxId
      /*  @ts-expect-error Jun-5-2024, 19:34UTC TODO: fix broken types introduced from typing of ThreadDetails record: https://git.hubteam.com/HubSpot/conversations-thread-view/pull/3656  */,
      genericChannelId: genericChannelId,
      visitorEmailAddress: visitorEmailAddress,
      properties: properties,
      showBlockThreadPrompt: showBlockThreadPrompt,
      showSendTranscriptPrompt: showSendTranscriptPrompt,
      showMoveToInboxPrompt: showMoveToInboxPrompt,
      showMarkAsSpamPrompt: showMarkAsSpamPrompt,
      setBlockThreadPrompt: setBlockThreadPrompt,
      setHasBlockBeenClicked: setHasBlockBeenClicked,
      setSendTranscriptPrompt: setSendTranscriptPrompt,
      setMoveToInboxPrompt: setMoveToInboxPrompt,
      setMarkAsSpamPrompt: setMarkAsSpamPrompt
    })]
  });
};
MoreActionsDropdown.displayName = 'MoreActionsDropdown';
export default MoreActionsDropdown;